// @flow
import React from 'react';

import Box from '@waglabs/box';
import Flex from '@waglabs/flex';
import H1 from '@waglabs/h1';
import Text from '@waglabs/text';

import { BodyContainer } from '../../../BodyContainer';
import dogImageDesktop from './assets/dog-with-wag-tag-desktop.png';
import dogImageMobile from './assets/dog-with-wag-tag-mobile.png';
import dogImageTablet from './assets/dog-with-wag-tag-tablet.png';

type Props = {
  search: string,
};


const HeadingContent = () => (
  <>
    <H1
      color="medGray"
      fontFamily="body"
      fontSize={[8, 10, 12]}
      fontWeight="bold"
      mb={0}
      pb={[3, 4]}
    >
      Free Wag! Tags for shelters
    </H1>
    <Text
      color="shelterGreen"
      fontSize={4}
      fontWeight="bold"
      mb={[3, 4]}
    >
      Shelter dogs work too hard to find their forever home to ever lose it.
    </Text>
    <Text
      color="medGray"
      fontFamily="body"
      fontSize={4}
      pb={4}
    >
      {'Wag! Tag is a smarter dog tag that gives anyone who finds a lost pet access to their unique online profile, with the info needed for a safe and speedy return. Wag! is donating them to rescue orgs across the country to give dogs and their new families the extra peace of mind they deserve.'}
    </Text>
  </>
);

const MobileHeading = ({
  search,
}: Props) => (
  <Box
    display={['block', 'none']}
  >
    <Box
      backgroundImage={`url(${dogImageMobile})`}
      backgroundPosition="top"
      backgroundSize="cover"
      height="250px"
    />

    <Box
      bg="backgroundGray"
      px={4}
      py={5}
    >
      <HeadingContent
        search={search}
      />
    </Box>
  </Box>
);

const TabletHeading = ({
  search,
}: Props) => (
  <Box
    display={['none', 'block']}
  >

    <Box
      bg="backgroundGray"
    >
      <BodyContainer
        flexDirection="row"
        maxWidth={['100%', '100%', 1120, 1600]}
        overflow="hidden"
      >
        <Flex
          flexDirection="column"
          ml={4}
          py={[0, '100px']}
          pr={[0, 4, '100px']}
          width="40%"
        >
          <HeadingContent
            search={search}
          />
        </Flex>

        <Flex
          alignSelf="stretch"
          width="60%"
          position="relative"
        >
          <Flex
            alignSelf="stretch"
            backgroundImage={['none', `url(${dogImageTablet})`, `url(${dogImageDesktop})`]}
            backgroundPosition="top"
            backgroundSize="cover"
            height="100%"
            position="absolute"
            width="100%"
          />
        </Flex>
      </BodyContainer>
    </Box>

  </Box>
);

export const Heading = ({
  search,
}: Props) => (
  <>
    <TabletHeading search={search} />
    <MobileHeading search={search} />
  </>
);
